// OGC scale denominators assume a pixel of 0.28 mm (WMS 1.3.0, 7.2.4.6.9)
const OGC_PIXEL_SIZE_METERS = 0.00028

// Servers often state the scale of a tile level itself (IGN: 1066.3647919248926 for level 19), which
// comes out a hair off the grid's resolution after the conversion
const RESOLUTION_TOLERANCE = 1e-6

export default {
  /**
   * The deepest level of a tile grid at which a WMS layer still draws. Past its MinScaleDenominator
   * the server answers with an empty image, so the map should enlarge this level instead.
   * @param {number[]} resolutions the tile grid's resolutions in map units per pixel, coarsest first
   * @param {number} metersPerUnit of the grid's projection
   * @param {number} minScaleDenominator the layer's MinScaleDenominator from GetCapabilities
   * @returns {number} index into resolutions
   */
  deepestZoomForMinScale (resolutions, metersPerUnit, minScaleDenominator) {
    const minResolution = (minScaleDenominator * OGC_PIXEL_SIZE_METERS) / metersPerUnit
    let zoom = 0
    while (zoom + 1 < resolutions.length && resolutions[zoom + 1] >= minResolution * (1 - RESOLUTION_TOLERANCE)) {
      zoom++
    }

    return zoom
  }
}
